<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="会员卡" />
    </van-sticky>
		<div class="search-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="(item,index) in tabData" :key="index" :class="'testing' + item.testingId">
          <!-- 信息 -->
          <div class="flex-row-between" style="padding-right: 16px">
            <!-- <div class="baseinfo flex-row-start">
              <div v-if="item.studentBasePO.name" class="font-intro">姓名：{{ item.studentBasePO.name }}</div>
              <div v-if="item.userAuthPO.name" class="font-intro">姓名：{{ item.userAuthPO.name }}</div>
            </div> -->
            <div class="baseinfo flex-row-start">
              <div class="font-bigger">{{ item.name }}</div>
            </div>
            <div class="font-bigger name">{{ item.testingName }}</div>
          </div>
          <!-- <van-cell title="名称" :value="item.testingName" :border="false" /> -->
          <!-- 按钮 -->
          <div class="bottom flex-row-between">
            <div class="state">￥{{ item.price }}</div>
            <div class="flex-row-end">
              <div>
                <van-button @click="payClick(item)" round type="primary" size="small">立即购买</van-button>
              </div>
            </div>
          </div>
        </div>
      </van-list>
		</div>
  </div>
</template>
<script>
import { isWeiXin } from '@/utils/tools'
import { h5Buy } from '@/api/testing-record'
import { auth } from '@/api/vip-card'
import { fetchVipCard } from "../../../api/vip-card"
export default {
  data() {
    return {
      typeBg: {
        'User': '../../../assets/images/user-bg.png',
        'Student': '../../../assets/images/student-bg.png'
      },
      searchValue: '',
      offset: 100,//滚动条与底部距离小于 offset 时触发load事件，默认300
      pageNum: -1, // 当前页码
      pageSize: 10, // 分页大小
      total: 0, // 查询总条数
      loading: false, // 滚动加载中
      finished: false, // 滚动加载完成
      tabData: []
    };
  },
  filters: {
    birthFilter(val) {
      if (val) {
        return val.split(' ')[0]
      }
      return val
    }
  },
  components: {
  },
  created() {
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    payClick(item) {
      // 支付
      // buyVipCard({
      //   vipCardId: item.id
      // }).then(res => {
      //   this.onBridgeReady(JSON.parse(res.payJson), item)
      // })
      if (isWeiXin()) {
          // 公众号支付
          auth({
            vipCardId: item.id
          }).then(res => {
            window.location.href = res
          })
        } else {
          // h5支付
          h5Buy({
            vipCardId: item.id
          }).then(res => {
            this.payOrderId = res.id
            localStorage.setItem('payOrderId', res.id)
            // 保存
            if (res.state.key == 'Succeed') {
              this.$router.push({
                path: '/mine',
                query: {
                }
              })
            } else {
              // 跳转支付
              location.href = res.payJson + '&redirect_url=' + encodeURIComponent(location.href.replace('index', 'mine') + '&t=' + new Date().getMilliseconds())
            }
          })
        }
    },
    onBridgeReady(data, item) {
      console.info(data)
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": data.appId,     //公众号ID，由商户传入
            "timeStamp": data.timeStamp + "",     //时间戳，自1970年以来的秒数
            "nonceStr": data.nonceStr,      //随机串
            "package": data.package1,
            "signType": data.signType,     //微信签名方式：
            "paySign": data.sign //微信签名
        },
        (res) => {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              this.$router.push({
                path: '/mine',
                query: {
                }
              })
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            }
        })
    },
    toAccurateTesting(item) {
      // 去精准问卷
      window.location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId='+ localStorage.getItem('Tel') +'&inspectOrder='+ item.times +'&role=1&allow=true&companyId='+ item.companyId +'&isEdit=1'
    },
    toTesting(item) {
      localStorage.setItem('TestingRecordId', item.id)
      this.$router.push({
        path: '/testing-info',
        query: {
          testingId: item.testingId,
          testingRecordId: item.id
        }
      })
    },
    showReport(url) {
      this.$router.push({
        path: "/show-report",
        query: {
          url: url
        },
      })
    },
    onClickLeft() {
      history.back()
    },
    init() {
      this.$nextTick(() => {
        this.handleButtonSearchInfors()
      })
    },
    //点击键盘上的搜索/回车按钮后触发
    handleEnterSearchInfors(val) {
      console.log(val);
    },
    handleButtonSearchInfors() {
      this.pageNum = 0
      this.tabData = []
      this.loadData()
    },
    // 滚动加载更多
    onLoad() {
      this.pageNum++
      this.loadData()
    },
    loadData() {
      fetchVipCard({
        keyWord: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }, {}).then(res => {
        var data = res.content
        this.loading = false
        this.tabData = this.tabData.concat(data)
        if (data.length < this.pageSize) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.search-container {
  padding: 0.66667rem;
  background-repeat: no-repeat;
  background-size: 100%;
}
.van-search {
  border-radius: 20px;
  /deep/ .van-search__content {
    background-color: #31607b;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #999;
  }
  /deep/ input::-moz-input-placeholder {
    color: #999;
  }
  /deep/ input::-ms-input-placeholder {
    color: #999;
  }
  /deep/ .van-field__control {
    color: #c28831;
  }
}
.van-search__action {
  background-image: radial-gradient(#d8ba79, #c28831);
  padding: 0 32px;
  margin: 0 20px 0 0;
  color: #1b2026;
  border-radius: 20px;
  div {
    font-size: 30px;
  }
}
.search-list {
  padding: 0 40px 40px 40px;
  .testing6 {
    margin-top: 40px;
    border-radius: 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/user-bg.png');
  }
  .testing5 {
    margin-top: 40px;
    border-radius: 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/student-bg.png');
  }
}
.custom-title {
  color: #999999;
}
.name {
  padding: 24px 24px 0 24px;
}
.content {
  color: #999!important;
  margin-top: 16px;
  padding-left: 24px;
  div {
    color: #999!important;
    margin-top: 8px;
  }
}
.state {
  font-weight: bold;
  color: #ff9e19;
}
.bottom {
  font-size: .32rem;
  padding: 24px;
}
.baseinfo {
  margin-top: 24px;
  padding-left: 24px;
  .sex {
    width: 24px;
    height: 24px;
    margin-top: 8px;
    margin-left: 8px;
  }
}
.detailinfo {
  padding-left: 24px;
  padding-top: 8px;
}
.headimg {
  border-radius: 50%;
  height: 120px;
  width: 120px;
}
.font-bigger {
  padding-right: 0px;
}
.font-intro {
  padding-right: 16px;
}
</style>